import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLinkWithCopyText } from '../../../../components/NavLinkWithCopyText';
import { getCurrencySelector } from '../../../../ducks/currency/selector';
import { getCurrencyThunk } from '../../../../ducks/currency/thunk';
import { bigIntDecimalsDivision, bigIntFormat } from '../../../../helpers/bignumber';
import { formatTimestamp } from '../../../../helpers/time';
import { useAppParams } from '../../../../hooks/useAppParams';
import { ThunkAppDispatch } from '../../../../store';
import { ICurrencyTransfer } from '../../../../types/currency';

export const CurrencyTransferRow: FC<ICurrencyTransfer> = ({
  transfer,
  timestamp,
  senderRS,
  recipientRS,
  units,
  currency,
}) => {
  const dispatch = useDispatch<ThunkAppDispatch>();
  const params = useAppParams();
  const currencyInfo = useSelector(getCurrencySelector(currency));

  useEffect(() => {
    if (!currencyInfo) {
      dispatch(getCurrencyThunk(currency));
    }
  }, [currencyInfo, dispatch, currency]);

  const currentPath = params.code
    ? `/transactions/currency/${params.code}/${transfer}`
    : `/transactions/${transfer}`;

  return (
    <tr>
      <td>
        <NavLinkWithCopyText path={currentPath} text={transfer} />
      </td>
      <td>
        {currencyInfo?.decimals
          ? bigIntFormat(bigIntDecimalsDivision(units, currencyInfo.decimals ?? 1))
          : ''}
      </td>
      <td>{params.code}</td>
      <td>{formatTimestamp(timestamp)}</td>
      <td>{formatTimestamp(timestamp - 7200)}</td>
      <td>
        <NavLinkWithCopyText path={`/accounts/${senderRS}`} text={senderRS} />
      </td>
      <td>
        <NavLinkWithCopyText path={`/accounts/${recipientRS}`} text={recipientRS} />
      </td>
    </tr>
  );
};
